export default "__VITE_PUBLIC_ASSET__5bc816b1__"